// src/config/environment.ts

// Environment configuration - SECURITY: No logging of environment variables
export const ENV = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '/api',
  USE_MOCK: false, // Force false to use real API
  MOCK_DELAY: parseInt(process.env.REACT_APP_MOCK_DELAY || '300'),
  NODE_ENV: process.env.NODE_ENV || 'development'
};
